export default {
    syslog: {
        log_trig_setting: 'Log Trigger Setting',
        time: 'Time',
        func_module: 'Function Module',
        operation_time: 'Operation Time',
        operation: 'Actions',
        operator: 'Operator',
        content: 'Email Content',
        methods: 'Request Method',
        param: 'Params',
        result: 'Return Result',
        operation_detail: 'Operation Details',

        //返回状态码
        code_0: 'Setting Failed',
        code_1: 'Setting Successful',
        code_other: 'Location Error'
    }
};
